'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dId$0024 from "./presto.types$-Grouping-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_Groupings$$anon$2(outer) {
  this.aW6 = null;
  this.aW4 = null;
  this.aW5 = false;
  this.aW2 = null;
  this.aW3 = false;
  this.aW7 = false;
  this.aW8 = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.aW6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_Groupings$$anon$2 as $c_Lpresto_Groupings$$anon$2 };
$p = $c_Lpresto_Groupings$$anon$2.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Groupings$$anon$2;
/** @constructor */
function $h_Lpresto_Groupings$$anon$2() {
}
export { $h_Lpresto_Groupings$$anon$2 as $h_Lpresto_Groupings$$anon$2 };
$h_Lpresto_Groupings$$anon$2.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.aW6;
});
$p.t = (function() {
  if ((!this.aW5)) {
    this.aW4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aW5 = true;
  }
  return this.aW4;
});
$p.ae = (function() {
  if ((!this.aW3)) {
    this.aW2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGrouping$002dId$0024.$m_Lpresto_types$GroupingId$().SO(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aW3 = true;
  }
  return this.aW2;
});
$p.w = (function() {
  if ((!this.aW8)) {
    this.aW7 = false;
    this.aW8 = true;
  }
  return this.aW7;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_Groupings$$anon$2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Groupings$$anon$2, "presto.Groupings$$anon$2", ({
  Jo: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_Groupings$$anon$2 as $d_Lpresto_Groupings$$anon$2 };
//# sourceMappingURL=presto.-Groupings$$anon$2.js.map
